export type PhaseStatus = 'done' | 'active' | 'upcoming';

export interface Phase {
  id: string;
  name: string;
  tag: string;
  start: string;
  end: string;
  status: PhaseStatus;
  summary: string;
  points: string[];
  action: string;
}

export interface Milestone {
  date: string;
  title: string;
  detail: string;
  kind: 'deadline' | 'vote' | 'result' | 'event';
}

export interface WeeklyEvent {
  date: string;
  weekday: string;
  time: string;
  title: string;
  place: string;
  tag: string;
}

export interface Highlight {
  id: string;
  index: string;
  title: string;
  text: string;
  image: string;
}

export interface Award {
  name: string;
  quota: string;
  prize: string;
  note: string;
}

export interface Voice {
  name: string;
  role: string;
  text: string;
}

export const PHASES: Phase[] = [
  {
    id: 'p1',
    name: '报名与海选征集',
    tag: '第一阶段',
    start: '2026-09-01',
    end: '2026-09-20',
    status: 'active',
    summary: '面向所有内容创作者开放报名，提交你的爆料线索与作品初稿，海选期不设门槛，新手也能直接上。',
    points: [
      '报名通道 9 月 1 日 10:00 开启，微信与网页端同步',
      '每人最多提交 3 份作品，题材不限但需为原创',
      '提交后可以随时修改，以截稿时刻的版本为准',
    ],
    action: '9 月 20 日 24:00 前完成提交',
  },
  {
    id: 'p2',
    name: '资格初审',
    tag: '第二阶段',
    start: '2026-09-21',
    end: '2026-09-25',
    status: 'upcoming',
    summary: '组委会对全部提交作品做原创性与合规性核验，剔除重复、搬运与材料不完整的条目。',
    points: [
      '核验原创度、时间线与信息来源',
      '材料不完整会通过站内信通知补正，补正窗口 48 小时',
      '通过初审的作品进入公示名单',
    ],
    action: '9 月 25 日 18:00 公示初赛入围名单',
  },
  {
    id: 'p3',
    name: '初赛公开投票',
    tag: '第三阶段',
    start: '2026-09-26',
    end: '2026-10-10',
    status: 'upcoming',
    summary: '入围作品开放公众投票，投票结果与专业评审分数按比例合成初赛成绩。',
    points: [
      '公众投票占初赛成绩 40%，评审打分占 60%',
      '每个账号每日可投 3 票，同一作品每日限 1 票',
      '投票期间实时展示票数，异常刷票将被清零',
    ],
    action: '10 月 10 日 22:00 投票通道关闭',
  },
  {
    id: 'p4',
    name: '复赛评审',
    tag: '第四阶段',
    start: '2026-10-11',
    end: '2026-10-25',
    status: 'upcoming',
    summary: '复赛阶段由评审团分组交叉打分，重点考察选题价值、信息完整度与叙事能力。',
    points: [
      '48 位评审随机分为 8 组交叉打分，去掉一个最高分与最低分',
      '选手可在 10 月 15 日前提交补充材料',
      '复赛成绩不计入决赛投票，仅决定晋级资格',
    ],
    action: '10 月 25 日 20:00 公布复赛结果',
  },
  {
    id: 'p5',
    name: '半决赛晋级',
    tag: '第五阶段',
    start: '2026-10-26',
    end: '2026-11-08',
    status: 'upcoming',
    summary: '复赛晋级作品进入半决赛，通过公开路演与限时答辩争夺决赛席位。',
    points: [
      '半决赛采用线上路演，每人 12 分钟陈述加 8 分钟问答',
      '路演录像赛后公开，接受监督',
      '半决赛前 10 名直接晋级决赛',
    ],
    action: '11 月 8 日 20:00 公布半决赛晋级名单',
  },
  {
    id: 'p6',
    name: '决赛冲刺',
    tag: '第六阶段',
    start: '2026-11-09',
    end: '2026-11-20',
    status: 'upcoming',
    summary: '决赛作品统一开放最终投票，同时由终审评审团完成最后一轮打分。',
    points: [
      '决赛票数与终审分数按 35% 与 65% 合成最终名次',
      '每日更新一次决赛进度榜，仅展示名次不展示分数',
      '最后 48 小时进入双倍投票时段',
    ],
    action: '11 月 20 日 22:00 决赛投票结束',
  },
  {
    id: 'p7',
    name: '结果公示与颁奖',
    tag: '第七阶段',
    start: '2026-11-21',
    end: '2026-11-30',
    status: 'upcoming',
    summary: '获奖名单公示五天，接受实名申诉；公示无异议后举办线下颁奖盛典并同步直播。',
    points: [
      '公示期 11 月 21 日至 11 月 25 日',
      '申诉需实名提交证据材料，逾期不受理',
      '11 月 30 日举办颁奖盛典，全程线上直播',
    ],
    action: '11 月 30 日 19:30 颁奖盛典直播',
  },
];

export const MILESTONES: Milestone[] = [
  { date: '2026-09-20', title: '海选截稿', detail: '报名与作品提交通道同时关闭，逾期不再补收。', kind: 'deadline' },
  { date: '2026-10-10', title: '初赛公投结束', detail: '公众投票通道 22:00 关闭，票数进入合成统计。', kind: 'vote' },
  { date: '2026-11-08', title: '半决赛晋级公布', detail: '前 10 名晋级决赛，名单与路演录像同步公开。', kind: 'result' },
  { date: '2026-11-20', title: '决赛投票截止', detail: '最后一轮投票结束，进入终审合分阶段。', kind: 'deadline' },
  { date: '2026-11-25', title: '获奖名单公示', detail: '五个工作日公示期结束，接受实名申诉。', kind: 'result' },
  { date: '2026-11-30', title: '颁奖盛典直播', detail: '19:30 开启直播，现场公布最终名次与单项奖。', kind: 'event' },
];

export const WEEKLY_EVENTS: WeeklyEvent[] = [
  { date: '09-10', weekday: '周三', time: '20:00', title: '线上答疑：怎么提交一份合格的爆料', place: '赛事直播间', tag: '答疑' },
  { date: '09-12', weekday: '周五', time: '12:00', title: '本周选题灵感清单更新', place: '官网公告区', tag: '素材' },
  { date: '09-14', weekday: '周日', time: '15:00', title: '创作者连线：往届入围选手经验谈', place: '赛事直播间', tag: '分享' },
  { date: '09-16', weekday: '周二', time: '19:30', title: '材料规范答疑专场', place: '赛事直播间', tag: '答疑' },
  { date: '09-20', weekday: '周日', time: '24:00', title: '海选截稿提醒，提交通道关闭', place: '全渠道公告', tag: '节点' },
];

export const HIGHLIGHTS: Highlight[] = [
  {
    id: 'h1',
    index: '01',
    title: '七阶段一条线，进度看得见',
    text: '从报名到颁奖拆成七个阶段，每个阶段的起止、任务和产出物都写在时间表里，不用再单独问客服。',
    image: 'https://readdy.ai/api/search-image?query=warm%20editorial%20flat%20lay%20of%20a%20hand-drawn%20timeline%20with%20seven%20numbered%20markers%2C%20terracotta%20and%20amber%20paper%20tones%2C%20clean%20cream%20background%2C%20minimal%20graphic%20poster%20composition%2C%20soft%20daylight&width=900&height=620&seq=baoliao-h1&orientation=landscape',
  },
  {
    id: 'h2',
    index: '02',
    title: '截稿与开投各自标红',
    text: '三类关键节点用不同标记区分：截稿、开投、出结果，日程表上第一眼就能找到最急的那件事。',
    image: 'https://readdy.ai/api/search-image?query=minimal%20calendar%20grid%20with%20a%20few%20highlighted%20dates%20in%20warm%20red%20and%20gold%2C%20cream%20paper%20texture%20background%2C%20flat%20editorial%20illustration%2C%20no%20text%2C%20clean%20geometric%20shapes&width=900&height=620&seq=baoliao-h2&orientation=landscape',
  },
  {
    id: 'h3',
    index: '03',
    title: '投票进度实时可查',
    text: '初赛与决赛期间每天更新一次进度榜，名次变化、剩余时间、双倍投票时段都能在页面里看到。',
    image: 'https://readdy.ai/api/search-image?query=abstract%20rising%20bar%20chart%20in%20terracotta%20orange%20and%20deep%20green%20on%20warm%20cream%20background%2C%20flat%20minimal%20editorial%20graphic%2C%20geometric%20shapes%2C%20no%20text&width=900&height=620&seq=baoliao-h3&orientation=landscape',
  },
  {
    id: 'h4',
    index: '04',
    title: '结果与排名分开讲',
    text: '晋级名单、获奖公示、最终名次分阶段公布，公示期还有实名申诉通道，过程留有记录。',
    image: 'https://readdy.ai/api/search-image?query=minimal%20podium%20and%20medal%20illustration%20in%20warm%20gold%20and%20terracotta%20tones%2C%20cream%20background%2C%20flat%20editorial%20poster%20style%2C%20clean%20geometric%20composition%2C%20no%20text&width=900&height=620&seq=baoliao-h4&orientation=landscape',
  },
];

export const AWARDS: Award[] = [
  { name: '金奖', quota: '1 名', prize: '赛事奖金 + 年度首页展示位', note: '决赛综合成绩第一名' },
  { name: '银奖', quota: '1 名', prize: '赛事奖金 + 专题报道', note: '决赛综合成绩第二名' },
  { name: '铜奖', quota: '1 名', prize: '赛事奖金 + 创作者扶持名额', note: '决赛综合成绩第三名' },
  { name: '最佳选题奖', quota: '1 名', prize: '专项奖金 + 选题孵化支持', note: '由评审团从入围作品中投票产生' },
  { name: '最佳叙事奖', quota: '1 名', prize: '专项奖金 + 写作工作坊名额', note: '表彰信息组织与表达突出的作品' },
  { name: '人气之星奖', quota: '1 名', prize: '专项奖金 + 联名周边', note: '公开投票阶段票数最高者' },
];

export const VOICES: Voice[] = [
  {
    name: '林知舟',
    role: '上届金奖项得主',
    text: '以前最头疼的是问不到准确时间，现在直接把时间表存进收藏夹，截稿前三天还会收到提醒，安心很多。',
  },
  {
    name: '周砚',
    role: '参赛选手',
    text: '阶段划分很细，每个阶段要交什么、什么时候出结果都写清楚了，照着日程走就不会漏。',
  },
  {
    name: '苏文文',
    role: '内容观察者',
    text: '投票进度每天更新一次，名次是怎么变化的能对得上，这点比只顾着拉票的赛制让人放心。',
  },
];